export const customHeaderFieldIds = [
    "2",  // Loan amount
    "4209", // Lock status
    "1401", // Milestone: setup complete
    "TPO.X90", // Milestone: submit for UW
    "MS.STATUS", // Status
    "CX.TPO.LOANNOTES.UNREAD.BROK", // unread notes
    "CX.EXC.PRE.REQ.DATE", // Exception date
    "CX.EXC.PRE.SEC.DEC", // Exception status
    "1811", // Occupancy
    "LOANFILESEQUENCENUMBER", // File sequence #
    "Log.MS.Stage", // Current milestone
    "CX.EXC.COMBINED.DECISION", // header exception status
    "4788",
    "CX.LOAN.PRODUCT.NAME", //DTI checking non income
    "HMDA.X36",//DTI if income
    "CX.LOAN.LOCK.STATUS", //ustom field having polly webhook lock status
    "740",
    "742", //DTI top/bottom
    "762",
    "Log.MS.LastCompleted",
    "CX.DOC.TYPE",
    "CX.DSCR.CALCULATED", //DSCR - with Asset Depletion
    "CX.LEGAL.ENTITY.TYPE",
    "2626", // Channel
    "TPO.X88", // Delegated or not (Y/N)
];

export const staticLoanFieldMap = {
    loanNumber: "364",
    borrowerName: "1868",
    coborrowerName: "1873",
    addressLine: "URLA.X73",
    city: "12",
    state: "14",
    postalCode: "15",
    companyName: "TPO.X14",
    initialInterestRate: "3",
    loanType: "1172",
    loanPurpose: "19",
    amortizationType: "608",
    amortizationTerm: "4",
    monthlyPI: "5",
    ltv: "353",
    hcltv: "1540",
    topRatio: "MORNET.X158",
    bottomRatio: "MORNET.X159",
    loanProgram: "1401",
    loantype: "CX.LOAN.TYPE",
    tpoOrgId: "TPO.X15",
    tpoUserId: "TPO.X62",
    tpoCorrUserId: "TPO.X96"
};

export const combinedHeaderFields = Array.from(
    new Set([
        ...customHeaderFieldIds,
        ...Object.values(staticLoanFieldMap)
    ])
);
